import { render, staticRenderFns } from "./TemplateTableTwo.vue?vue&type=template&id=3c8a6be8&scoped=true&"
import script from "./TemplateTableTwo.vue?vue&type=script&lang=js&"
export * from "./TemplateTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTableTwo.vue?vue&type=style&index=0&id=3c8a6be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a6be8",
  null
  
)

export default component.exports